import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rmSlash'
})
export class RmSlashPipe implements PipeTransform {

  transform(content: string | null | undefined): string | null {
    return content ? content.replaceAll(/(?<!<)\//g, '') : null;
  }

}
